export const jobDetails = {
  "sales-executive": {
    title: "Sales Executive",
    details: (
      <ul className="list-unstyled">
        <li>0-3 Years of experience in sales</li>
        <li>Sales and Customer Relationship Management skills</li>
        <li>Management skills</li>
        <li>Strategy Development and Planning skills</li>
        <li>Excellent communication and negotiation skills</li>
        <li>
          Results-driven with a strong track record of meeting or exceeding
          sales targets
        </li>
        <li>
          Ability to analyze market trends and prepare detailed sales reports
        </li>
        <li>Bachelor's degree in Business, Marketing, or a related field</li>
      </ul>
    )
  },
  "sales-manager": {
    title: "Sales Manager",
    details: (
      <div>
        <h5 className="fw-bold">Job Summary:</h5>
        <p>
          The Real Estate Sales Manager is responsible for developing and
          executing the sales strategy for residential or commercial projects.
          This includes managing the sales team, driving revenue growth, and
          ensuring exceptional customer experience.
        </p>

        <h5 className="fw-bold">Key Responsibilities:</h5>
        <ul>
          <li>
            Develop and implement strategic sales plans to meet revenue targets.
          </li>
          <li>
            Recruit, train, and manage a team of real estate sales executives.
          </li>
          <li>Assign individual sales targets and monitor team performance.</li>
          <li>
            Drive site visits and ensure effective conversion of leads into
            bookings.
          </li>
          <li>
            Maintain strong relationships with channel partners, brokers, and
            direct clients.
          </li>
          <li>
            Analyze sales performance data and market trends to adjust
            strategies.
          </li>
          <li>
            Coordinate with the marketing team for campaign execution and event
            planning.
          </li>
          <li>
            Handle escalated client queries and support closure of high-value
            deals.
          </li>
          <li>
            Prepare detailed sales reports and projections for senior
            management.
          </li>
        </ul>

        <h5 className="fw-bold">Qualifications:</h5>
        <ul>
          <li>Bachelor’s degree in Business, Marketing, or Real Estate.</li>
          <li>
            4–7 years of experience in real estate sales, with at least 2 years
            in a leadership role.
          </li>
          <li>
            Proven track record of team leadership and meeting sales targets.
          </li>
          <li>
            Excellent communication, negotiation, and team management skills.
          </li>
          <li>
            Sound knowledge of RERA guidelines, documentation processes, and
            local property market.
          </li>
          <li>
            Tech-savvy with experience in CRM systems and reporting tools.
          </li>
        </ul>
      </div>
    )
  },
  "site-engineer": {
    title: "Site Engineer",
    details: (
      <div>
        <h5 className="fw-bold">Job Summary:</h5>
        <p>
          We are looking for a skilled Site Engineer to manage day-to-day
          construction activities and ensure projects are executed on time,
          within budget, and with high quality standards.
        </p>

        <h5 className="fw-bold">Key Responsibilities:</h5>
        <ul>
          <li>
            Supervise on-site construction work and ensure adherence to design,
            quality, and safety standards.
          </li>
          <li>
            Coordinate with contractors, vendors, and labor teams for smooth
            execution.
          </li>
          <li>Check drawings, layouts, and quantities to ensure accuracy.</li>
          <li>
            Monitor project progress and prepare daily/weekly site reports.
          </li>
          <li>
            Ensure materials are used as per specifications and manage site
            inventory.
          </li>
          <li>Resolve technical/site issues and escalate as needed.</li>
          <li>
            Ensure compliance with safety regulations and company policies.
          </li>
          <li>
            Liaise with project managers, architects, and clients for project
            updates.
          </li>
        </ul>

        <h5 className="fw-bold">Qualifications:</h5>
        <ul>
          <li>Diploma / B.E. / B.Tech – Civil Engineering.</li>
          <li>
            2–6 years of experience in real estate, construction, or
            infrastructure projects.
          </li>
          <li>
            Strong knowledge of construction methods, materials, and legal
            regulations.
          </li>
          <li>Ability to read and interpret technical drawings and plans.</li>
          <li>Excellent site supervision and problem-solving skills.</li>
          <li>Good communication and coordination abilities.</li>
          <li>
            Knowledge of MS Office, AutoCAD, and project management tools
            preferred.
          </li>
        </ul>

        <h5 className="fw-bold">Additional Information:</h5>
        <ul>
          <li>Location: Chennai</li>
          <li>Industry: Real Estate / Construction / Infrastructure</li>
          <li>Salary: As per industry standards</li>
          <li>Employment Type: Full Time</li>
        </ul>
      </div>
    )
  },
  "accounts-executive": {
    title: "Accounts Executive",
    details: (
      <div>
        <h5 className="fw-bold">Job Summary:</h5>
        <p>
          We are seeking a detail-oriented Accounts Executive to manage
          day-to-day accounting operations, maintain accurate financial records,
          and support the finance team in ensuring compliance and timely
          reporting.
        </p>

        <h5 className="fw-bold">Key Responsibilities:</h5>
        <ul>
          <li>
            Maintain books of accounts, general ledger, and financial
            statements.
          </li>
          <li>
            Handle accounts payable/receivable, invoicing, and bank
            reconciliation.
          </li>
          <li>Prepare GST, TDS, and other statutory returns.</li>
          <li>Assist in payroll processing and employee expense management.</li>
          <li>
            Coordinate with auditors and support in finalization of accounts.
          </li>
          <li>Prepare MIS reports and ensure timely submission.</li>
          <li>Monitor budgets, cash flow, and expense tracking.</li>
          <li>
            Ensure compliance with accounting standards and company policies.
          </li>
        </ul>

        <h5 className="fw-bold">Qualifications:</h5>
        <ul>
          <li>B.Com / M.Com</li>
          <li>1–4 years of experience in accounting or finance.</li>
          <li>
            Strong knowledge of accounting principles and taxation (GST/TDS).
          </li>
          <li>Proficiency in Tally ERP, MS Excel, and accounting software.</li>
          <li>Analytical mindset with attention to detail.</li>
          <li>Good communication and coordination skills.</li>
          <li>Ability to work independently and meet deadlines.</li>
        </ul>

        <h5 className="fw-bold">Additional Information:</h5>
        <ul>
          <li>Location: Chennai</li>
          <li>Industry: Real Estate / Construction / Infrastructure / Any</li>
          <li>Salary: As per industry standards</li>
          <li>Employment Type: Full Time</li>
        </ul>
      </div>
    )
  },
  "land-acquisition-bd": {
  title: "Land Acquisition – Business Development",
  details: (
    <div>
      <h5 className="fw-bold">Job Summary:</h5>
      <p>
        We are looking for a Land Acquisition professional to support our real
        estate/infrastructure projects by identifying and acquiring suitable
        land parcels. The role involves site visits, initial negotiations,
        assisting in documentation, and coordinating with landowners, brokers,
        and government offices.
      </p>

      <h5 className="fw-bold">Key Responsibilities:</h5>
      <ul>
        <li>Identify potential land parcels for development projects.</li>
        <li>Conduct site visits and collect ground-level information.</li>
        <li>Build and maintain strong relationships with landowners, brokers, and local stakeholders.</li>
        <li>Support negotiations with landowners and intermediaries.</li>
        <li>Coordinate with legal and liaison teams for title verification and documentation.</li>
        <li>Assist in preparing agreements, records, and reports.</li>
        <li>Work with government offices (revenue, registration, municipal) for approvals and clearances.</li>
        <li>Track land market trends and share insights with management.</li>
      </ul>

      <h5 className="fw-bold">Qualifications:</h5>
      <ul>
        <li>Graduate in any discipline.</li>
        <li>8–15 years of experience in land acquisition, real estate, or related field.</li>
        <li>Knowledge of land records, registration process, and local laws.</li>
        <li>Good communication and interpersonal skills.</li>
        <li>Ability to travel frequently and work with local communities.</li>
      </ul>

      <h5 className="fw-bold">Additional Information:</h5>
      <ul>
        <li>Email: <a href="mailto:marketing@anandhamplots.com">marketing@anandhamplots.com</a></li>
      </ul>
    </div>
  )
}

};
